
import { defineComponent } from "vue";
import slideInfo from "../slide-info/slide-info.vue";

import { Swiper, SwiperSlide } from "swiper/vue";
import SwiperCore, { Autoplay, EffectFade, Lazy } from "swiper";
import { ImagePreview } from "vant";
require("swiper/swiper.less");
require("swiper/components/effect-fade/effect-fade.less");
require("swiper/components/lazy/lazy.less");

const SWIPER_COMPONENTS = {
  Swiper,
  SwiperSlide,
};

SwiperCore.use([Autoplay, EffectFade, Lazy]);
export default defineComponent({
  components: {
    slideInfo,
    ...SWIPER_COMPONENTS
  },

  data() {
    return {
      swiperList: [{
        name: '月嫂见面会',
        imgList: [
          'https://mm2015.mamalaile.com.cn/7ed2b9cbffdcf4eb11bc504bb6a20ce6.png',
          'https://mm2015.mamalaile.com.cn/77e653f41ac04593f9daa37e05a481f4.png',
          'https://mm2015.mamalaile.com.cn/7433420a7f3891c08f2dc2965249a96d.png',
          'https://mm2015.mamalaile.com.cn/fb0aa79ce8ed79aeab54d115f8689d5f.png',
          'https://mm2015.mamalaile.com.cn/5a516059c15308352bb64a79934573d5.png',
        ]
      }, {
        name: '月嫂直播',
        imgList: [
          'https://mm2015.mamalaile.com.cn/ca38b33d18d71b810f0c5cc407c76cca.png',
          'https://mm2015.mamalaile.com.cn/a34ae617b01b08d6e3241b53d198e02c.png',
          'https://mm2015.mamalaile.com.cn/02293325236e9969efae87709862e06a.png',
          'https://mm2015.mamalaile.com.cn/e2c93eb922e715edcaf1f95229da89bc.png',
        ]
      }, {
        name: '月子餐试吃',
        imgList: [
          'https://mm2015.mamalaile.com.cn/bd52b2c5e272daaffbb995598441800d.png',
          'https://mm2015.mamalaile.com.cn/535feea966ab1c2d8d3345fc510d714f.png',
          'https://mm2015.mamalaile.com.cn/7739cea93e8221699874e38a9cb9a960.png',
          'https://mm2015.mamalaile.com.cn/627022e9497706f1cc999f4cda60f3cd.png',
          'https://mm2015.mamalaile.com.cn/74661caad7b52f7ed8175b0d96025502.png',
        ]
      }]
    };
  },

  methods: {
    previewImage(index: number, imgIndex: number) {
      ImagePreview({
        images: this.swiperList[index].imgList,
        startPosition: imgIndex,
        closeable: true,
      });
    }
  }
});
